'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-question';
var width = 512;
var height = 512;
var aliases = [62108,"question-circle"];
var unicode = 'f059';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm160-48c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.9-21.2 56.3-41.1 67.2-17.5 9.6-30.9 25-30.9 42 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-25.5 19.5-45.2 39.2-56 16.7-9.1 32.8-25 32.8-53.1 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 4.4-3.6 8-8 8s-8-3.6-8-8zm96 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M496 256a240 240 0 1 0 -480 0 240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM256 144c-35.3 0-64 28.7-64 64 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.9-21.2 56.3-41.1 67.2-17.5 9.6-30.9 25-30.9 42 0 4.4-3.6 8-8 8s-8-3.6-8-8c0-25.5 19.5-45.2 39.2-56 16.7-9.1 32.8-25 32.8-53.1 0-35.3-28.7-64-64-64zM240 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;